"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var navigation_1 = require("next/navigation");
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Timer_1 = __importDefault(require("./Timer"));
var YouParticipate_1 = __importDefault(require("./YouParticipate"));
var BannerWithTitleTimer = function () {
    var _a, _b, _c;
    var t = (0, next_intl_1.useTranslations)('translation');
    var _d = (0, swr_hooks_1.useActiveTournaments)(), data = _d.data, isLoading = _d.isLoading;
    var translateLocale = (0, swr_hooks_1.useLocaleTranslations)();
    var _e = (0, swr_hooks_1.useJoinTournament)(), joinTournament = _e.joinTournament, isSubmitting = _e.isSubmitting;
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var signUpNavigate = (0, apps_shared_1.useOpenSignUp)();
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var router = (0, navigation_1.useRouter)();
    var currentTournament = (0, react_1.useMemo)(function () { return data === null || data === void 0 ? void 0 : data[0]; }, [data]);
    var isUserParticipate = (0, react_1.useMemo)(function () {
        return !!(currentTournament === null || currentTournament === void 0 ? void 0 : currentTournament.me);
    }, [currentTournament]);
    var isFinished = (currentTournament === null || currentTournament === void 0 ? void 0 : currentTournament.endDate)
        ? new Date(currentTournament === null || currentTournament === void 0 ? void 0 : currentTournament.endDate) < new Date()
        : false;
    var onClickHandler = (0, react_1.useCallback)(function (e) {
        var _a;
        if (!isUserParticipate) {
            if (currentTournament === null || currentTournament === void 0 ? void 0 : currentTournament.id)
                router.push(generateUrlWithLang("/tournaments/".concat((_a = currentTournament.baseTournament) === null || _a === void 0 ? void 0 : _a.slug)));
        }
    }, [currentTournament, generateUrlWithLang, router, isUserParticipate]);
    var participate = (0, react_1.useCallback)(function (id) {
        if (!isAuth)
            return signUpNavigate();
        if (id)
            joinTournament({ id: id });
    }, [joinTournament, signUpNavigate, isAuth]);
    if (!currentTournament && !isLoading)
        return null;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container, onClick: onClickHandler },
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title },
                react_1.default.createElement("span", null, t('tournament')),
                ' ',
                react_1.default.createElement(Timer_1.default, { endDate: currentTournament === null || currentTournament === void 0 ? void 0 : currentTournament.endDate })),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.bonusTitle }, translateLocale((_a = currentTournament === null || currentTournament === void 0 ? void 0 : currentTournament.baseTournament) === null || _a === void 0 ? void 0 : _a.name)),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.bonusDescription }, translateLocale(((_c = (_b = currentTournament === null || currentTournament === void 0 ? void 0 : currentTournament.baseTournament) === null || _b === void 0 ? void 0 : _b.descriptions) === null || _c === void 0 ? void 0 : _c.short) || '')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonWrapper }, !isUserParticipate ? (!isFinished ? (react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", width: "100%", maxWidth: "336px", height: "56px", onClick: function (e) {
                    e === null || e === void 0 ? void 0 : e.stopPropagation();
                    participate(currentTournament === null || currentTournament === void 0 ? void 0 : currentTournament.id);
                }, loading: isSubmitting }, t('joinNow'))) : null) : (react_1.default.createElement(YouParticipate_1.default, null))))));
};
exports.default = BannerWithTitleTimer;
